// Auto-generated normalizer for table: PoliticasABAC
export function politicasABACNormalize(row) {
  return {
    idPolitica: row.idPolitica ?? row.IdPolitica ?? row['IdPolitica'] ?? 0,
    idAtributo: row.idAtributo ?? row.IdAtributo ?? row['IdAtributo'] ?? 0,
    idOperador: row.idOperador ?? row.IdOperador ?? row['IdOperador'] ?? 0,
    nombrePolitica: row.nombrePolitica ?? row.NombrePolitica ?? row['NombrePolitica'] ?? '',
    valorEsperado: row.valorEsperado ?? row.ValorEsperado ?? row['ValorEsperado'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
